import type { SUPPORTED_COUNTRY } from "@shared-kernel/domain/types/supported-country";
import type { AddressLookup } from "./address-lookup";

interface BasePostalAddress {
  address: string;
  addressComplement: string | null;
  city: string;
  country: SUPPORTED_COUNTRY;
  department: string | null;
  region: string | null;
  latitude: number;
  longitude: number;
  externalPlaceId: string | null;
}

export interface AdministrativePostalAddress extends BasePostalAddress {
  postalCode: string;
}

export interface TrainingLocation extends BasePostalAddress {
  postalCode: string | null;
}

export const formatPostalAddress = (postalAddress: BasePostalAddress & { postalCode: string | null }): string => {
  const postalCodePart = postalAddress.postalCode ? `${postalAddress.postalCode} ` : "";
  return `${postalAddress.address}, ${postalCodePart}${postalAddress.city}`;
};

export const postalAddressToAddressLookup = (postalAddress: AdministrativePostalAddress | TrainingLocation): AddressLookup => ({
  placeId: postalAddress.externalPlaceId ?? "",
  description: formatPostalAddress(postalAddress),
  sessionToken: "",
  invalid: postalAddress.externalPlaceId === null,
});
